import Glide from '@glidejs/glide';
export function initializeCarousel() {
  var glideElement = document.querySelector('.glide');
  if (glideElement) {
    var glideInstance = new Glide(glideElement, {
      type: 'carousel',
      startAt: 0,
      perView: 3,
      gap: 10,
      breakpoints: {
        1024: {
          perView: 3
        },
        640: {
          perView: 2
        },
        480: {
          perView: 1
        }
      },
      autoplay: 3000 // Si quieres autoplay
    });
    glideInstance.mount();
    console.log('Glide se ha montado correctamente.');
  } else {
    /* console.error("El contenedor '.glide' no se encuentra en el DOM."); */
  }
}